module.exports = __webpack_public_path__ + "img/antilopay_sbp.4934e64f.png";